import { useState } from "react";
import { Layout } from "../components/Layout";
import { Card } from "../components/Card";
import { Button } from "../components/Button";
import { Banner } from "../components/Banner";
import "./AuthForm.css";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const resp = await fetch("/api/auth/login", {
        method: "POST",
        credentials: "include",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      if (!resp.ok) {
        const body = await resp.json().catch(() => ({})) as { error?: string };
        setErr(body.error ?? `Login failed (${resp.status})`);
        return;
      }
      window.location.href = "/dashboard";
    } catch (e2) {
      setErr((e2 as Error).message ?? "Network error");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Layout>
      <div className="auth-form-wrap">
        <Card>
          <div className="auth-form-head">
            <span className="label">Sign in</span>
            <h1>Welcome back</h1>
            <p style={{ color: "var(--color-bone-dim)", margin: "8px 0 0" }}>
              Sign in to keep watch on your accounts.
            </p>
          </div>

          {err && <Banner tone="err">{err}</Banner>}

          <form className="auth-form" onSubmit={submit}>
            <label>
              <span className="auth-form__label">Email</span>
              <input
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={busy}
              />
            </label>
            <label>
              <span className="auth-form__label">Password</span>
              <input
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={busy}
              />
            </label>
            <Button type="submit" disabled={busy}>
              {busy ? "Signing in…" : "Sign in"}
            </Button>
          </form>

          <p className="auth-form__foot">
            Accounts are set up by invitation. Your Retrofit AI contact can get you access.
          </p>
        </Card>
      </div>
    </Layout>
  );
}
